/* Shop-Interaktionen, ohne Framework */
(function () {
  "use strict";

  var doc = document;
  var root = doc.documentElement;
  var routes = window.routes || { cart_url: "/cart", cart_add_url: "/cart/add", cart_change_url: "/cart/change" };
  var settings = window.themeSettings || { cartType: "drawer" };
  var isEditor = !!(window.Shopify && window.Shopify.designMode);

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }

  /* ---------- Kopfhöhe als CSS-Variable ---------- */
  function headHeight() {
    var h = $(".head");
    if (h) root.style.setProperty("--head", h.offsetHeight + "px");
  }
  headHeight();
  window.addEventListener("resize", headHeight);

  /* ---------- Ladeanzeige ---------- */
  var pre = $("[data-pre]");
  if (pre) {
    var seen = false;
    try { seen = window.sessionStorage.getItem("ms-pre") === "1"; } catch (e) {}
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (seen || reduce || isEditor) {
      root.classList.add("pre-done");
      if (pre.parentNode) pre.parentNode.removeChild(pre);
    } else {
      root.classList.add("locked");
      var pct = $("[data-pre-pct]", pre), bar = $("[data-pre-bar]", pre);
      var t0 = performance.now(), shown = 0, loaded = doc.readyState === "complete", done = false;
      window.addEventListener("load", function () { loaded = true; });
      var finish = function () {
        if (done) return;
        done = true;
        pct.textContent = "100";
        bar.style.transform = "scaleX(1)";
        try { window.sessionStorage.setItem("ms-pre", "1"); } catch (e) {}
        setTimeout(function () {
          root.classList.add("pre-done");
          root.classList.remove("locked");
          setTimeout(function () { if (pre.parentNode) pre.parentNode.removeChild(pre); }, 800);
        }, 200);
      };
      (function step(now) {
        var t = (now - t0) / 1000;
        var target = loaded ? shown + 4 + t : Math.min(t / 1.5, 1) * 88;
        shown = Math.min(100, Math.max(shown, target));
        pct.textContent = String(Math.floor(shown));
        bar.style.transform = "scaleX(" + shown / 100 + ")";
        if ((shown >= 99.5 && loaded) || t > 4) { finish(); return; }
        requestAnimationFrame(step);
      })(performance.now());
    }
  }

  /* ---------- Feine Linie unter der Kopfzeile beim Scrollen ---------- */
  var headEl = $(".head");
  if (headEl) {
    var stick = function () { headEl.classList.toggle("stuck", window.scrollY > 8); };
    window.addEventListener("scroll", stick, { passive: true });
    stick();
  }

  /* ---------- Eigener Cursor ---------- */
  if (doc.body.classList.contains("cur-on")
      && window.matchMedia("(hover: hover) and (pointer: fine)").matches
      && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var dot = doc.createElement("div"), ring = doc.createElement("div");
    dot.className = "cur"; ring.className = "cur-ring";
    doc.body.appendChild(dot); doc.body.appendChild(ring);
    var mx = -60, my = -60, rx = -60, ry = -60;
    doc.addEventListener("mousemove", function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = "translate(" + mx + "px," + my + "px)";
    }, { passive: true });
    (function follow() {
      rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
      ring.style.transform = "translate(" + rx + "px," + ry + "px)";
      requestAnimationFrame(follow);
    })();
    doc.addEventListener("mouseover", function (e) {
      ring.classList.toggle("on", !!e.target.closest("a, button, summary, label, select, input"));
    });
    doc.addEventListener("mouseleave", function () { mx = my = -60; });
  }

  /* ---------- Mobiles Menü ---------- */
  function initMenu() {
    var b = $("[data-burger]"), m = $("[data-mnav]");
    if (!b || !m || b.dataset.on) return;
    b.dataset.on = "1";
    function set(open) {
      m.classList.toggle("on", open);
      b.classList.toggle("on", open);
      b.setAttribute("aria-expanded", open ? "true" : "false");
      b.setAttribute("aria-label", open ? "Menü schließen" : "Menü öffnen");
      root.classList.toggle("locked", open);
    }
    b.addEventListener("click", function () { set(!m.classList.contains("on")); });
    $$("a", m).forEach(function (a) { a.addEventListener("click", function () { set(false); }); });
    window.addEventListener("resize", function () { if (window.innerWidth >= 900) set(false); });
  }
  initMenu();

  /* ---------- Mengen-Buttons ---------- */
  doc.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qminus], [data-qplus]");
    if (!b) return;
    var input = $("input", b.parentNode);
    if (!input) return;
    var min = parseInt(input.getAttribute("min") || "0", 10);
    var val = parseInt(input.value || "0", 10) || 0;
    input.value = b.hasAttribute("data-qminus") ? Math.max(min, val - 1) : val + 1;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- Warenkorb ---------- */
  var lastFocus = null;
  function drawer() { return $("[data-drawer]"); }
  function useDrawer() { return !!drawer() && settings.cartType !== "page"; }

  function openCart() {
    var d = drawer();
    if (!d) return;
    lastFocus = doc.activeElement;
    d.classList.add("on");
    d.setAttribute("aria-hidden", "false");
    root.classList.add("locked");
    var p = $(".drawer__panel", d);
    if (p) setTimeout(function () { p.focus(); }, 50);
  }
  function closeCart() {
    var d = drawer();
    if (!d || !d.classList.contains("on")) return;
    d.classList.remove("on");
    d.setAttribute("aria-hidden", "true");
    root.classList.remove("locked");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function paintDrawer(html) {
    var d = drawer();
    if (!d || !html) return;
    var tmp = doc.createElement("div");
    tmp.innerHTML = html;
    var fresh = $(".drawer__panel", tmp), cur = $(".drawer__panel", d);
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  function paintCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.setAttribute("data-zero", n === 0 ? "true" : "false");
      el.classList.add("pop");
      setTimeout(function () { el.classList.remove("pop"); }, 320);
    });
  }

  doc.addEventListener("click", function (e) {
    if (e.target.closest("[data-drawer-close]")) { e.preventDefault(); closeCart(); return; }
    var open = e.target.closest("[data-cart-open]");
    if (open && useDrawer()) { e.preventDefault(); openCart(); return; }

    var line = e.target.closest("[data-line]");
    if (line && window.fetch) {
      e.preventDefault();
      var d = drawer();
      if (d) d.classList.add("load");
      fetch(routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          line: parseInt(line.getAttribute("data-line"), 10),
          quantity: Math.max(0, parseInt(line.getAttribute("data-q"), 10) || 0),
          sections: ["cart-drawer"],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections && cart.sections["cart-drawer"]) paintDrawer(cart.sections["cart-drawer"]);
          if (typeof cart.item_count === "number") paintCount(cart.item_count);
        })
        .catch(function () { window.location.href = routes.cart_url; })
        .then(function () { if (d) d.classList.remove("load"); });
    }
  });

  doc.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    closeCart();
    var m = $("[data-mnav]");
    if (m && m.classList.contains("on")) $("[data-burger]").click();
  });

  /* Fokus im offenen Warenkorb halten */
  doc.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var d = drawer();
    if (!d || !d.classList.contains("on")) return;
    var f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', d)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Produktseite ---------- */
  function initPdp(sec) {
    var form = $("[data-pform]", sec);
    if (!form || form.dataset.on) return;
    form.dataset.on = "1";

    var map = {};
    var mapEl = $("[data-vmap]", sec);
    try { map = JSON.parse(mapEl ? mapEl.textContent : "{}"); } catch (err) { map = {}; }

    var vid = $("[data-vid]", form);
    var priceEl = $("[data-price]", sec);
    var addBtn = $("[data-add]", form);
    var addLabel = $("[data-add-label]", form);
    var skuEl = $("[data-sku]", sec);
    var msg = $("[data-msg]", form);
    var sets = $$("[data-oi]", form);

    function picked() {
      return sets.map(function (fs) { var c = $("input:checked", fs); return c ? c.value : null; });
    }
    function find(opts) {
      var ids = Object.keys(map);
      for (var i = 0; i < ids.length; i++) {
        var v = map[ids[i]], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return { id: ids[i], v: v };
      }
      return null;
    }
    function markGone() {
      var opts = picked();
      sets.forEach(function (fs, idx) {
        $$("input", fs).forEach(function (inp) {
          var t = opts.slice();
          t[idx] = inp.value;
          var m = find(t);
          if (inp.nextElementSibling) inp.nextElementSibling.classList.toggle("gone", !m || !m.v.available);
        });
      });
    }
    function sync() {
      var m = find(picked());
      if (msg) msg.textContent = "";
      if (!m) { addBtn.disabled = true; addLabel.textContent = "Nicht verfügbar"; return; }
      vid.value = m.id;
      if (priceEl) priceEl.innerHTML = m.v.price + (m.v.hasCompare ? '<s class="was">' + m.v.compare + "</s>" : "");
      addBtn.disabled = !m.v.available;
      addLabel.textContent = m.v.available ? "In den Warenkorb" : "Ausverkauft";
      if (skuEl) skuEl.textContent = m.v.sku || m.id;
      if (window.history && window.history.replaceState && window.URL) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", m.id);
        window.history.replaceState({}, "", u.toString());
      }
      markGone();
    }
    sets.forEach(function (fs) { fs.addEventListener("change", sync); });
    if (sets.length) markGone();

    form.addEventListener("submit", function (e) {
      if (!useDrawer() || !window.fetch) return;
      e.preventDefault();
      if (window.ShopPreview) { openCart(); return; }
      addBtn.classList.add("busy");
      var data = new FormData(form);
      data.append("sections", "cart-drawer");
      data.append("sections_url", window.location.pathname);
      fetch(routes.cart_add_url + ".js", {
        method: "POST",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: data
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok || res.body.status) {
            if (msg) msg.textContent = res.body.description || res.body.message || "Das hat nicht geklappt. Versuch es bitte noch einmal.";
            return null;
          }
          if (res.body.sections && res.body.sections["cart-drawer"]) paintDrawer(res.body.sections["cart-drawer"]);
          return fetch(routes.cart_url + ".js", { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { paintCount(cart.item_count); openCart(); });
        })
        .catch(function () { form.submit(); })
        .then(function () { addBtn.classList.remove("busy"); });
    });

    var dlg = $("[data-size-dialog]", sec);
    $$("[data-size-open]", sec).forEach(function (b) {
      b.addEventListener("click", function () { if (dlg && dlg.showModal) dlg.showModal(); });
    });
    if (dlg) {
      dlg.addEventListener("click", function (e) {
        if (e.target === dlg || e.target.closest("[data-size-close]")) dlg.close();
      });
    }
  }
  $$("[data-pdp]").forEach(initPdp);

  /* ---------- Sortierung ---------- */
  $$("[data-sort]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("sort_by", sel.value);
      u.searchParams.delete("page");
      window.location.href = u.toString();
    });
  });

  /* ---------- Warenkorbseite speichert Mengen automatisch ---------- */
  var cf = $("#CartForm");
  if (cf) {
    var t;
    cf.addEventListener("change", function (e) {
      if (e.target.name !== "updates[]") return;
      clearTimeout(t);
      t = setTimeout(function () { cf.submit(); }, 500);
    });
  }

  /* ---------- Theme-Editor ---------- */
  if (isEditor) {
    doc.addEventListener("shopify:section:load", function (e) {
      initMenu();
      headHeight();
      $$("[data-pdp]", e.target).forEach(initPdp);
    });
  }
})();
